import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import ChainingProvider from '../classes/ChainingProvider'
import { ChainingProviderDto } from '../types/ChainingProvider/ChainingProviderDto'

export class ChainingProviderApiAdapter implements ApiDataAdapter<ChainingProvider> {
    public createClass(apiData: ChainingProviderDto): ChainingProvider {
        return new ChainingProvider(
            Number(get(apiData, 'id')), //@TODO API returns number instead of string
            get(apiData, 'code'),
            get(apiData, 'libelle'),
            get(apiData, 'actif'),
        )
    }
}
